export const isURL = stateParam => {
  const urlPattern = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(:\d+)?(\/[^\s]*)?$/i;
  const decodedUrl = decodeURIComponent(stateParam);
  return urlPattern.test(decodedUrl);
};

export default isURL;
